import React from 'react';
import { View } from 'react-native';

import { ViewPropTypes, TextPropTypes } from 'deprecated-react-native-prop-types';
import PropTypes from 'prop-types';

import { VFText } from '@vfgroup-oneplatform/foundation/Components';

import styles from './RecommendedBadge.Styles';

const RecommendedBadge = ({ i18nKey, containerStyle, textStyle, ...props }) => {
  return (
    <View style={[styles.containerStyle, containerStyle]} {...props}>
      <VFText i18nKey={i18nKey} style={[styles.textStyle, textStyle]} />
    </View>
  );
};

RecommendedBadge.propTypes = {
  i18nKey: PropTypes.string,
  containerStyle: ViewPropTypes.style,
  textStyle: TextPropTypes.style,
};

export default RecommendedBadge;
